module.exports = __webpack_public_path__ + "static/media/DH4212F0.9a128603.png";